import React, { useState } from 'react';
import api from '../services/api';

const stamp = value => value ? new Date(value).toLocaleString('de-DE') : 'Unbekannt';
const capability = { supported:'Mit diesem Status und Build vorgesehen', unsupported:'Mit diesem Status und Build nicht möglich', unknown:'Unbekannt' };

export default function DispatchReview({ rideId, reviews = [], onChanged }) {
  const [reason,setReason]=useState('');
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  if (!reviews.length) return null;
  async function resolve(review, action) {
    if (!reason.trim() || busy) return;
    setBusy(true);setError('');
    try {
      if (action === 'resume') await api.post(`/admin/rides/${rideId}/dispatch-review/resume`,
        {expected_case_id:review.id,reason:reason.trim()});
      else await api.post(`/admin/rides/${rideId}/cancel`,{cancel_reason:reason.trim(),expected_case_id:review.id});
      setReason('');onChanged?.();
    } catch (_) { setError('Entscheidung nicht gespeichert. Bitte Fahrt neu laden.'); }
    finally {setBusy(false);}
  }
  return <section aria-label="GPS-Rückgabeprüfung">
    <h3>GPS-Rückgabeprüfung</h3>
    <p>Standortmuster zur manuellen Prüfung. Kein Nachweis eines Fehlverhaltens und keine automatische Gebühr.</p>
    {reviews.map(review => <article key={review.id}>
      <strong>{review.state === 'open' ? 'Vermittlung angehalten' : `Prüfung beendet: ${review.resolution || 'Unbekannt'}`}</strong>
      {review.evidence ? <dl>
        <dt>Abholung</dt><dd>{stamp(review.evidence.pickup.first_at_ms)} bis {stamp(review.evidence.pickup.last_at_ms)} · {review.evidence.pickup.distance_m} m Abstand</dd>
        {review.evidence.departure && <><dt>Belegte Wegfahrt</dt><dd>{stamp(review.evidence.departure.first_at_ms)} bis {stamp(review.evidence.departure.last_at_ms)} · {review.evidence.departure.distance_from_pickup_m} m von der Abholung</dd></>}
        <dt>Ziel</dt><dd>{stamp(review.evidence.destination.first_at_ms)} bis {stamp(review.evidence.destination.last_at_ms)} · {review.evidence.destination.distance_m} m Abstand</dd>
        <dt>App bei Rückgabe</dt><dd>{review.evidence.platform || 'Unbekannt'} · Build {review.evidence.app_build || 'Unbekannt'} · Status {review.evidence.return_status}</dd>
        <dt>Belegstand</dt><dd>Zuweisung {review.evidence.assignment_version ?? 'Unbekannt'} · Abholrevision {review.evidence.pickup_relocation_version ?? 'Unbekannt'} · Route {review.evidence.route_revision ?? 'Unbekannt'}</dd>
        <dt>Startfähigkeit</dt><dd>{capability[review.evidence.start_capability] || capability.unknown}</dd>
      </dl> : <p>Belege sind nach der Aufbewahrungsfrist nicht mehr verfügbar. Der Prüfstatus allein beweist keinen Fahrtablauf.</p>}
      {review.state === 'open' && <div>
        <p>Fahrer über die vorhandene Zuweisung wählen, die Vermittlung freigeben oder den Auftrag abbrechen.</p>
        <label>Begründung <input value={reason} maxLength={200} onChange={e=>setReason(e.target.value)} /></label>
        <button type="button" disabled={busy || !reason.trim()} onClick={()=>resolve(review,'resume')}>Vermittlung freigeben</button>
        <button type="button" disabled={busy || !reason.trim()} onClick={()=>resolve(review,'cancel')}>Auftrag abbrechen</button>
      </div>}
    </article>)}
    {error && <p role="alert">{error}</p>}
  </section>;
}
